export function compareCaseInsensitive(a, b) {
  const aVal = a.toUpperCase();
  const bVal = b.toUpperCase();
  if (aVal < bVal) {
    return -1;
  } else if (aVal > bVal) {
    return 1;
  }
  return 0;
}

export const nameFromUrl = resource => {
  let title
  let href = resource;
  const parser = document.createElement("a");
  parser.href = href;

  if (parser.pathname.length <= 1) {
    title = decodeURIComponent(parser.hostname);
  } else {
    title = decodeURIComponent(parser.pathname).replace("/", "");
  }
  return title;
};

export function encodeHtml(str) {
  if (str) {
    // https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  return '';
}
